import React from "react";
import { Platform, Pressable, StyleSheet, View } from "react-native";
import Icon from "react-native-vector-icons/Ionicons";
import { PlaceText } from "./components/PlaceText";

export const ARVideoPlayerTab = ({ navigation, route }: any) => {
    const videoUrl = route?.params?.videoUrl;

    if (Platform.OS !== "web" || !videoUrl) {
        return <View style={styles.page}><PlaceText style={styles.message}>Vídeo indisponível.</PlaceText></View>;
    }

    return <View style={styles.page}>
        {React.createElement("video", {
            src: videoUrl,
            controls: true,
            autoPlay: true,
            playsInline: false,
            style: styles.video as any,
        })}
        <Pressable style={styles.closeButton} onPress={() => navigation.goBack()}>
            <Icon name="close" size={30} color="#fff" />
        </Pressable>
    </View>;
};

const styles = StyleSheet.create({
    page: { flex: 1, backgroundColor: "#000", alignItems: "center", justifyContent: "center" },
    video: { width: "100%", height: "100%", backgroundColor: "#000", objectFit: "contain" },
    closeButton: { position: "absolute", top: 20, right: 20, width: 48, height: 48, borderRadius: 24, alignItems: "center", justifyContent: "center", backgroundColor: "rgba(0,0,0,0.58)" },
    message: { color: "#fff", fontSize: 16 },
});
